import React, { useState } from "react";
import { Button, Message, Input } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";
import { useIntl } from "react-intl";
import IntlMessages from "@util/IntlMessages";

import "./AdSenseSettings.less";

let AdSenseSettings = ({ value }) => {
   const intl = useIntl();
   const dispatch = useDispatch();
   const [settings, setSettings] = useState({
      ...value
   });
   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };

   return (
      <form onSubmit={handleSubmit}>
         <div className="widget-settings">
            <div className="widget-settings__inner">
               <label className="widget-settings__inner__label">
                  <IntlMessages id="settings.dataAdSlot" />:
                  <Input
                     name="dataAdSlot"
                     onChange={handleChange}
                     defaultValue={settings.dataAdSlot}
                  />
               </label>
               <label className="widget-settings__inner__label">
                  <IntlMessages id="settings.dataAdClient" />:
                  <Input
                     onChange={handleChange}
                     defaultValue={settings.dataAdClient}
                     name="dataAdClient"
                  />
               </label>
            </div>

            <Button htmlType="submit" buttonType="primary" className="adsense-settings__submit">
               <IntlMessages id="global.submit" />
            </Button>
         </div>
      </form>
   );
};

export default AdSenseSettings;
